import _extends from "@babel/runtime/helpers/esm/extends"
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"
import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { mapToCssModules, tagPropType } from "reactstrap/src/utils"
var propTypes = {
  color: PropTypes.string,
  pill: PropTypes.bool,
  tag: tagPropType,
  innerRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.string,
  ]),
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  style: PropTypes.object,
}
var defaultProps = {
  color: "secondary",
  pill: false,
  tag: "span",
}

var Badge = function Badge(props) {
  var className = props.className,
    cssModule = props.cssModule,
    color = props.color,
    innerRef = props.innerRef,
    pill = props.pill,
    Tag = props.tag,
    attributes = _objectWithoutPropertiesLoose(props, [
      "className",
      "cssModule",
      "color",
      "innerRef",
      "pill",
      "tag",
    ])

  var classes = mapToCssModules(
    classNames(
      className,
      "badge",
      "bg-" + color,
      pill ? "rounded-pill" : false
    ),
    cssModule
  )

  if (attributes.href && Tag === "span") {
    Tag = "a"
  }

  return /*#__PURE__*/ React.createElement(
    Tag,
    _extends({}, attributes, {
      className: classes,
      style: props.style,
      ref: innerRef,
    })
  )
}

Badge.propTypes = propTypes
Badge.defaultProps = defaultProps
export default Badge
